import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';

import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBarConfig } from '@angular/material/snack-bar';

import { MatSnackBar } from '@angular/material/snack-bar';

import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConstitucionPolizaCredito, PolizaCredito } from '../../../models/finanzas/poliza-credito/poliza-credito.model';

import { PolizaCreditoListComponent } from './poliza-credito-list.component';

import { PolizaCreditoService } from '../../../services/finanzas/poliza-credito/poliza-credito.service';

import { consts } from '../../../consts';

import { ActivityModel } from '../../user/activity/activity.model';

import { ActivityService } from '../../user/activity/activity.service';
import { MasterModel } from '../../../modules_v2/master/models/master.model';
import { MasterService } from '../../../modules_v2/master/services/master.service';
import { ActualSelected } from '../../../shared/utils';

@Component({
    selector: 'convfact-poliza-credito-constitucion',
    templateUrl: './poliza-credito-dialog-constitucion.component.html',
    styleUrls: ['./poliza-credito.component.css'],
    standalone: false
})

export class PolizaCreditoDialogConstitucionComponent implements OnInit {

  public polizaCredito: PolizaCredito = this.data.polizaCredito;

  public constitucionPolizaCredito: ConstitucionPolizaCredito = {

    uid: '0',

    polizaCreditoId: '',

    fecha: new Date(),

    comisionApertura: 0,

    descripcion: '',

    activitiesUid: consts.EMPTY_GUID,

    activitiesName: '',

  };

  public saved: boolean = false;

  public ready: boolean = false;

  public isEditMode: boolean = false;

  public list: boolean = false;

  public dataSource: ConstitucionPolizaCredito[] = [];

  public headerTable: any[] = [

    { field: 'fecha', title: 'Fecha', cell: (row) => `${new Date(row.fecha).toLocaleDateString()}`, class: (row) => `` },

    { field: 'comisionApertura', title: 'Comisión apertura', cell: (row) => `${row.comisionApertura}  `, class: (row) => `` },

    { field: 'descripcion', title: 'Descripción', cell: (row) => `${row.descripcion}  `, class: (row) => `` }

  ];

  private changesAtModal: boolean = false;

  public activities: ActivityModel[] = [];
  projects: MasterModel[] = [];
  expenseProjectTypes: MasterModel[] = [];
  isProjectEnable: boolean = false;


  constructor(

    public dialogRef: MatDialogRef<PolizaCreditoListComponent>,

    public polizaCreditoService: PolizaCreditoService,

    @Inject(MAT_DIALOG_DATA) public data: any,

    public snackBar: MatSnackBar,

    public activityService: ActivityService,
    private cdr: ChangeDetectorRef,
    private masterService: MasterService,

  ) { }

  public ngOnInit(): void {

    this.activityService.getList()

      .then(response => {

        this.activities = response;

      });


    //Projects

    this.masterService.getProjects().subscribe(data => {
      this.projects = data;
      this.cdr.detectChanges();
    })

    //Expense Project Types
    this.masterService.getExpenseProjectTypes().subscribe(data => {
      this.expenseProjectTypes = data;
      this.cdr.detectChanges();
    })

    this.activityService.loadData(ActualSelected.activitySelected).then(activity => {
          this.isProjectEnable = activity.isProject;
        });


    this.getData();

  }

  public save(): void {

    this.constitucionPolizaCredito.polizaCreditoId = this.polizaCredito.uid;

    let noError: boolean = true;

    // Validations

    if (this.constitucionPolizaCredito.fecha == null) {
      noError = false;
    }

    if (this.constitucionPolizaCredito.descripcion == null || this.constitucionPolizaCredito.descripcion == '') {
      noError = false;
    }

    if (this.constitucionPolizaCredito.comisionApertura == null) {
      noError = false;
    }

    if (this.constitucionPolizaCredito.activitiesUid == null) {
      noError = false;
    }

    //project
    if (noError) {

      this.constitucionPolizaCredito.projectUid = this.constitucionPolizaCredito.projectUid;

  }

  //Expense
    if (noError) {

      this.constitucionPolizaCredito.expenseProjectTypeUid = this.constitucionPolizaCredito.expenseProjectTypeUid;

  }


    // Request

    if (noError) {
      this.changesAtModal = true;

      if (this.isEditMode === false) {

        this.polizaCreditoService.constitucionCreate(this.constitucionPolizaCredito)

          .then(response => {

            this.saved = true;

          })

          .catch(err => {

            this.displayInfo("Ha ocurrido un error inesperado al añadir la constitución");

          });

      }

      if (this.isEditMode === true) {

        this.polizaCreditoService.constitucionUpdate(this.constitucionPolizaCredito)

          .then(response => {

            this.saved = true;

          })

          .catch(err => {

            this.displayInfo("Ha ocurrido un error inesperado al actualizar la constitución");

          });

      }

    } else {

      this.displayInfo("Compruebe que tiene los campos rellenados correctamente");

    }

  }

  public getData(): void {

    this.saved = false;

    this.ready = false;

    this.polizaCreditoService.constitucionList(this.polizaCredito.uid)

      .then(response => {

        this.dataSource = response;

        if (this.dataSource.length > 0) {

          this.list = true;

        }

        this.ready = true;

      })

      .catch(error => {

        this.ready = true;

      });

  }

  public delete(uidElement: string): void {

    this.changesAtModal = true;

    // Este uid es el id

    this.polizaCreditoService.constitucionDelete(uidElement)

      .then(response => {

        this.getData();

      })

      .catch(err => {

        this.displayInfo("Ha ocurrido un error al eliminar la constitución");

      });

  }

  public edit(uidElement: string): void {

    const elementSearched = this.dataSource.find(f => f.uid == uidElement);

    this.isEditMode = true;

    this.saved = false;

    this.constitucionPolizaCredito = elementSearched;

  }

  public displayInfo(message: string): void {

    const options = new MatSnackBarConfig();

    options.duration = 10000;

    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);

  }

  public closeDialog(): void {

    this.dialogRef.close(this.changesAtModal);

  }

  public trackByIndex(i: number) { return i; }

}

